export default __webpack_public_path__ + "static/media/2005.3e41da54.png";